export default __webpack_public_path__ + "static/media/electrical-switching-room-v3.77a7c9cc.jpg";